// Semanas de domingo a sábado; la semana 1 es la que contiene el 1 de enero.
const DAY = 86400000;
const utc = (y, m, d) => Date.UTC(y, m, d);

export const week1Start = (year) => {
  const j1 = utc(year, 0, 1);
  return j1 - new Date(j1).getUTCDay() * DAY;
};

export const weekBounds = (year, week) => {
  const s = week1Start(year) + (week - 1) * 7 * DAY;
  return [new Date(s), new Date(s + 6 * DAY)];
};

export const weekOf = (d = new Date()) => {
  const t = utc(d.getFullYear(), d.getMonth(), d.getDate());
  const sat = t + (6 - new Date(t).getUTCDay()) * DAY;
  const y = new Date(sat).getUTCFullYear();
  return { year: y, week: Math.floor((t - week1Start(y)) / (7 * DAY)) + 1 };
};

export const weeksInYear = (year) => Math.round((week1Start(year + 1) - week1Start(year)) / (7 * DAY));

export const fmtD = (d) => (typeof d === "string" ? new Date(`${d}T12:00:00Z`) : d)
  .toLocaleDateString("es-MX", { day: "2-digit", month: "short", year: "numeric", timeZone: "UTC" });

export const weekLabel = (year, week) => {
  const [s, e] = weekBounds(year, week);
  return `Semana ${week} · ${fmtD(s)} – ${fmtD(e)}`;
};

export const money = (v) => (v == null ? "—" : `$${Number(v).toFixed(2)}`);

export const fmtDT = (iso) => (iso ? new Date(iso).toLocaleString("es-MX", {
  day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
